// Embark Customizations
// Embark Mega Menu
function embarkMegaMenu() {
  const hasMega = document.querySelectorAll('.has-embark-mega')

  hasMega.forEach((menu) => {
    const navItems = menu.querySelectorAll('.link-nav li');
    const contentLists = menu.querySelectorAll('.link-grid .grid-item');
    // console.log(`menu: ${menu} \n navItems: ${navItems.length}, \n contentLists: ${contentLists.length}`)
    // Attach hover event to each nav item
    if (navItems.length && contentLists.length) {
      navItems.forEach((item) => {
        item.addEventListener('mouseenter', function () {
          contentLists.forEach((list) => {
            list.classList.remove('active');
          });
          navItems.forEach((item) => {
            item.classList.remove('active');
          });
          const handle = this.getAttribute('data-handle');
          const correspondingList = document.querySelector(`.link-grid .grid-item[data-handle="${handle}"]`);
          if (correspondingList) {
            correspondingList.classList.add('active');
            item.classList.add('active');
          }
        });
      });

      // Set the first item as active by default
      const firstNavItem = navItems[0];
      const firstHandle = firstNavItem.getAttribute('data-handle');
      const firstList = document.querySelector(`.link-grid .grid-item[data-handle="${firstHandle}"]`);
      if (firstList) {
        firstList.classList.add('active');
        firstNavItem.classList.add('active');
      }
    };

    let maxHeight = 0;
    menu.addEventListener('mouseenter', function () {
      // Loop through each ul to find the maximum height
      contentLists.forEach((ul) => {
        const height = ul.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Set the CSS variable --megaHeight for the menu
      menu.style.setProperty('--megaHeight', `${maxHeight}px`);
    });
  });
}


document.addEventListener('DOMContentLoaded', function () {
  embarkMegaMenu();
  // Get all navigation items with dropdowns
  const navItems = document.querySelectorAll('li.has-dropdown.header__linklist-item');

  // Map to keep track of timeout IDs for each dropdown
  const timeoutIds = new Map();

  // Function to hide all dropdowns except for the current one
  const hideAllDropdownsExcept = (currentDropdown) => {
    document.querySelectorAll('.mega-menu, .nav-dropdown').forEach(dropdown => {
      if (dropdown !== currentDropdown && dropdown.hasAttribute('hidden') === false) {
        dropdown.setAttribute('hidden', '');
      }
    });
  };

  // Function to show the dropdown
  const showDropdown = (dropdown) => {
    // Clear any existing timeout for this dropdown
    if (timeoutIds.has(dropdown)) {
      clearTimeout(timeoutIds.get(dropdown));
      timeoutIds.delete(dropdown);
    }
    hideAllDropdownsExcept(dropdown);  // Hide all other dropdowns first
    dropdown.removeAttribute('hidden');
  };

  navItems.forEach(item => {
    // Mouse enter event to handle dropdown visibility
    item.addEventListener('mouseenter', () => {
      const dropdown = item.querySelector('.mega-menu, .nav-dropdown');
      if (dropdown) {
        showDropdown(dropdown);
      }
    });

    // Mouse leave event to hide the dropdown with a delay
    item.addEventListener('mouseleave', () => {
      const dropdown = item.querySelector('.mega-menu, .nav-dropdown');
      // Set a delay before hiding the dropdown
      const timeoutId = setTimeout(() => {
        dropdown.setAttribute('hidden', '');
      }, 500);
      timeoutIds.set(dropdown, timeoutId);
    });

    // Handling nested dropdowns with similar hover and delay effects
    item.querySelectorAll('.nav-dropdown__item.has-dropdown').forEach(nestedItem => {
      const nestedDropdown = nestedItem.querySelector('.nav-dropdown');

      nestedItem.addEventListener('mouseenter', () => {
        clearTimeout(timeoutIds.get(nestedDropdown)); // Cancel the timeout to hide the dropdown
        if (nestedDropdown) {
          nestedDropdown.removeAttribute('hidden');
        }
      });

      nestedItem.addEventListener('mouseleave', () => {
        // Apply the same delay as for the main dropdowns
        const timeoutId = setTimeout(() => {
          nestedDropdown.setAttribute('hidden', '');
        }, 500);
        timeoutIds.set(nestedDropdown, timeoutId);
      });
    });
  });
});


function setDefaults(prefs) {
  if (typeof prefs !== "undefined" && prefs !== null) {
    //Update Nav - If Default
    if (embark.prefs().default) {
      $(".truck_greeting").text(embark.messaging.truck_not_selected);
      $(".mobile-nav > .select_truck").hide();
      $(".mobileTruck").hide();
      $(".container.mainNav_menu_wrapper .truck_menu_content ul").hide();
      $(".defaultMegaMenu").show();
    } else {
      $(".truck_greeting").text(embark.messaging.truck_selected);
      $(".mobile-nav > .select_truck").show();
      $(".mobileTruck").show();
      $(".container.mainNav_menu_wrapper .truck_menu_content ul").show();
      $(".defaultMegaMenu").hide();
      $(".truck_menu_content").removeClass("d-none");
    }
    $("#truckTitle span").text(prefs.title);

    //Update Truck Selector
    modelSelector.find('[value="' + prefs.model + '"]').prop("checked", true);

    //Unhide All
    $("#select_gen").children("span").children("option").unwrap();
    $("#select_gen").children("option").show();
    //Hide All
    $("#select_gen").children('option:not([value="select_gen"])').hide();
    $("#select_gen").children('option:not([value="select_gen"])').wrap("<span></span>");
    //Show Selected
    $("#select_gen").children("span").children('option[value^="' + prefs.model + '"]').unwrap();
    $("#select_gen").children('option[value^="' + prefs.model + '"]').show();
    genSelector.val(prefs.gen).change();
  }
  else if (prefs == null) {
    $("#truckTitle span").text(select_your_truck);
    $(".select_truck p").text(truck_not_selected);
    $(".mobileTruck").hide();

    //Unhide All
    $("#select_gen").children("span").children("option").unwrap();
    $("#select_gen").children("option").show();
    //Hide All
    $("#select_gen").children('option:not([value="select_gen"])').hide();
    $("#select_gen").children('option:not([value="select_gen"])').wrap("<span></span>");
    genSelector.val("select_gen").change();
  }

  //Delay for Navbar Menu selections - Embark
  $(".mainNav li").hover(
    function () {
      var megaId = $(this).data("menu");
      var navChild = "#desktop-menu--" + megaId;
      var megaParent = '[data-menu="' + megaId + '"] > a';
      $(this).hover(function () {
        $(".mega-menu").css("transition-delay", "0s");
      },
        function () {
          $(".mega-menu").css("transition-delay", "0s");
          $(navChild).attr("hidden", true);
        });

      clearTimeout(window.mainNavSubMenuTimeout);
      window.navitem = $(this);
      window.mainNavSubMenuTimeout = setTimeout(function () {
        //Close all mega menus on hover
        $(".mega-select").attr("hidden", true);
        if (window.navitem.hasClass("has-mega-menu")) {
          //Toggle corresponding mega menu
          $(navChild).attr("hidden", false);
          $(navChild).hover(
            function () {
              $(this).attr("hidden", false);
              $(".mega-menu").css("transition-delay", "0s");
              $(megaParent).addClass("mega-hovered");
            },
            function () {
              $(this).attr("hidden", true);
              $(".mega-menu").css("transition-delay", "0.5s");
              $(megaParent).removeClass("mega-hovered");
            }
          );
        }
      }, 200);
    },
    function () {
      clearTimeout(window.mainNavSubMenuTimeout);
    }
  );
}

function removeSubMenus() {
  var subMenus = document.querySelectorAll('.mainNavSubMenu_Wrapper');
  subMenus.forEach(function (element) {
    element.remove();
  });
}


const modelSelector = $("#select_model");
const genSelector = $("#select_gen");
const truckSelector = $("#truck_selector");
const select = $("#truckConfirm");
const clearSelection = $("#truckClear");
//const truckPreference = getLocalStorage();

$("#truckConfirm").prop("disabled", true);
// Truck Selector Controls
modelSelector.on("change", () => {
  //console.log('Model Selected');
  $("#truckConfirm").prop("disabled", true);
  genSelector.find(":selected").prop("selected", false);
  genSelector.val("select_gen").change();
});

genSelector.on("change", () => {
  //const selected = genSelector.find(":selected");
  if (genSelector.val() != "select_gen" && genSelector.val() != null) {
    //console.log('Gen Selected');
    $("#truckConfirm").prop("disabled", false);
  };
});

select.on("click", (event) => {
  // get preferences from selection
  const model = modelSelector.find(":checked").attr("value");
  const selected = genSelector.find(":selected");
  genSelector.find(":selected").prop("selected", false);
  selected.prop("selected", true);
  const gen = selected.attr("value");
  const title = selected.html();

  if (gen != "select_gen") {
    // Call the function to remove elements
    removeSubMenus();
    // update preferences
    //setLocalStorage(model, gen, title);
    embark.setTruckPrefs(model, gen, title);
    embark.buildMenus();
    $(".truck_menu_content").removeClass("d-none");
    $('#truck_popover .popover__close-button[data-action="close"]').click();
    setDefaults(embark.prefs());
    initializeSplide();
  }
});

clearSelection.on("click", () => {
  localStorage.removeItem("ddc-embark");
  modelSelector.find(":checked").prop("checked", false);
  embark.buildMenus();
  setDefaults(embark.prefs());
  $("#truckConfirm").prop("disabled", true);
  //console.info("Truck Selection Cleared");
  // Call the function to remove elements
  $(".truck_menu_content").addClass("d-none");
  removeSubMenus();
});

/* Shows/Hides Models to match selected trucks */
//$("#select_gen").children('option:gt(0)').hide();
$('input[name="truck_radio_buttons"]').on("click", function () {
  //Unwrap Selected
  $("#select_gen")
    .children("span")
    .children('option[value^="' + $(this).val() + '"]')
    .unwrap();
  $("#select_gen")
    .children('option[value^="' + $(this).val() + '"]')
    .show();

  //Wrap Unselected
  $("#select_gen")
    .children(
      'option:not([value^="' +
      $(this).val() +
      '"]):not([value^="select_gen"])'
    )
    .hide();
  $("#select_gen")
    .children(
      'option:not([value^="' +
      $(this).val() +
      '"]):not([value^="select_gen"])'
    )
    .wrap("<span></span>");
});

//setDefaults(truckPreference);
setDefaults(embark.prefs());

// Show Truck Notication Popover first time a truck is selected
// Check if local storage value is set to true
var truckPopover = document.getElementById('truck_notification');
var truckConfirmButton = document.getElementById('truckConfirm');
// Add a click event listener to the truckConfirm button
truckConfirmButton.addEventListener('click', function () {
  var truckNotification = localStorage.getItem('ddc-truck-notification');
  if (!truckNotification || truckNotification !== 'true') {
    // Set the local storage value to true
    localStorage.setItem('ddc-truck-notification', 'true');
    truckPopover.setAttribute('open', '');
  }
});

// Keeps submenus in the screenport on hover
document.querySelectorAll('.nav-dropdown__item.has-dropdown').forEach(item => {
  item.addEventListener('mouseenter', function () {
    const subMenu = this.querySelector('.nav-dropdown');
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      if (rect.right > viewportWidth) {
        subMenu.style.left = 'unset';
        subMenu.style.right = '100%';
      } else {
      }
    }
  });
});

// Product Page
var zoomButton = document.querySelector(".product__zoom-button");
if (zoomButton) {
  zoomButton.addEventListener("click", function () {
    document.body.classList.add('product-image-fullscreen');
  })
}


// $.ajax({
//   url: 'https://geolocation-db.com/jsonp',
//   jsonpCallback: 'callback',
//   dataType: 'jsonp',
//   success: function (location) {
//     if (
//       location.country_code === 'CA' &&
//       ['NWT', 'NU', 'YT'].includes(location.state)
//     ) {
//       $('body').addClass('shipping-bar-hide');
//     }
//   },
//   error: function () {
//     console.log('Error occurred while retrieving geolocation data');
//   }
// });

// Appends filter to hide discontinued products by default to all collection URL's
// document.addEventListener('DOMContentLoaded', function () {
//   var parameterToAdd = '&filter.p.m.default.view=1';

//   // Select all anchor elements on the page
//   var links = document.querySelectorAll('a');

//   // Iterate through each link
//   links.forEach(function (link) {
//     var href = link.getAttribute('href');

//     // Check if the link contains '/collections/'
//     if (href && href.includes('/collections/')) {
//       // Append the parameter to the URL
//       var separator = (href.indexOf('?') !== -1) ? '&' : '?';
//       link.setAttribute('href', href + separator + parameterToAdd);
//     }
//   });
// });

console.info("Embark - Customizations Loaded");